import React, { useEffect, useRef } from 'react';

function Modal({ children, onClose, zIndex = 1000 }) {
  const contentRef = useRef(null);

  // Guarda a função de fecho mais recente sem reiniciar o efeito do foco.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const previousFocus = document.activeElement;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        onCloseRef.current?.();
      }
      if (event.key === 'Tab' && contentRef.current) {
        const elements = Array.from(
          contentRef.current.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => element.getClientRects().length > 0);

        if (!elements.length) {
          event.preventDefault();
          contentRef.current.focus();
          return;
        }
        const first = elements[0];
        const last = elements[elements.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === contentRef.current)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    const focusTimer = window.setTimeout(() => {
      const first = contentRef.current?.querySelector('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href]');
      (first || contentRef.current)?.focus();
    }, 0);

    return () => {
      window.clearTimeout(focusTimer);
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) {
        previousFocus.focus();
      }
    };
  }, []); // Executa ao abrir o modal e limpa apenas ao fechar.

  return (
    <div
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'safe center',
        overflowY: 'auto',
        padding: 'clamp(12px, 3vw, 28px)',
        boxSizing: 'border-box',
        backgroundColor: 'rgba(6, 8, 12, 0.78)',
        backdropFilter: 'blur(7px)',
        WebkitBackdropFilter: 'blur(7px)',
      }}
    >
      <div
        ref={contentRef}
        role="dialog"
        aria-modal="true"
        aria-label="Janela de diálogo"
        tabIndex={-1}
        style={{
          width: '100%',
          maxWidth: 'min(100%, 920px)',
          maxHeight: 'calc(100dvh - 24px)',
          overflowY: 'auto',
          outline: 'none',
          borderRadius: 18,
          boxShadow: '0 24px 80px rgba(0, 0, 0, 0.45)',
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default Modal;